import { LookupType } from './lookup-type';

export class GenericLookup {
  // Required
  lookupType: LookupType;

  // Optional
  queryObject?: object;
  width?: string;
}

export class GenericLookupResult {
  id: number;
  name: string;
  // optional type
  lookupType?: LookupType;
}
